// extracted by mini-css-extract-plugin
export var hidden = "_pj-1";
export var visible = "_pj-0";